import { useNavigate, useLocation } from 'react-router-dom'

export default function BottomNav() {
  const navigate = useNavigate()
  const location = useLocation()
  
  const isActive = (path: string) => location.pathname === path
  
  return (
    <div style={{
      position: 'fixed',
      bottom: 0,
      left: 0,
      right: 0,
      background: 'var(--gradient-primary)',
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      boxShadow: '0 -5px 20px rgba(0, 0, 0, 0.1)',
      zIndex: 1000,
      height: '60px'
    }}>
      <button
        style={{
          padding: '0',
          backgroundColor: isActive('/fast3') ? 'rgba(255, 255, 255, 0.1)' : 'transparent',
          border: 'none',
          color: 'white',
          fontSize: '1em',
          fontWeight: 'bold',
          cursor: 'pointer',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '3px',
          transition: 'background 0.3s ease'
        }}
        onClick={() => navigate('/fast3')}
      >
        <span style={{ fontSize: '1.3em' }}>🎲</span>
        <span style={{ fontSize: '0.85em' }}>快三</span>
      </button>
      <button
        style={{
          padding: '0',
          backgroundColor: isActive('/profile') ? 'rgba(255, 255, 255, 0.1)' : 'transparent',
          border: 'none',
          color: 'white',
          fontSize: '1em',
          fontWeight: 'bold',
          cursor: 'pointer',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '3px',
          transition: 'background 0.3s ease'
        }}
        onClick={() => navigate('/profile')}
      >
        <span style={{ fontSize: '1.3em' }}>👤</span>
        <span style={{ fontSize: '0.85em' }}>我的</span>
      </button>
    </div>
  )
}